import React, { useState } from 'react';
import { useForm } from '../../hooks/useForm';    

const Form = ({ initialValues, inputsConfig, onSubmit, handleError }) => {
    const { form, handleChange, validate, handleSubmit, resetForm, error, getInputProps } = useForm(initialValues);
  
    return (
        <div>
          <form
            autoComplete="off"
            className="space-y-4"
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit(onSubmit, handleError);
            }}
          >
            {inputsConfig.map((inputConfig, index) => {
              const { name } = inputConfig;
    
              return (
                <div key={index} className="mb-3">
                  <label htmlFor={inputConfig.id} className="form-label text-sm text-blue-500 font-semibold">
                    {inputConfig.label}
                  </label>
                  <input
                    className={inputConfig.className}
                    {...getInputProps(inputConfig)} // Pasamos las props generadas por el custom hook
                  />
                  {error?.[name] && <p>{error[name]}</p>} {/* Muestra el error específico del campo */}
                </div>
              );
            })}
    
            <div className="flex items-center justify-center">
              <button type="submit" className="flex items-center justify-center w-50 py-2 bg-blue-500 text-white font-semibold rounded-full hover:bg-blue-600 transition-colors">Enviar <span className="ml-2 text-lg">&rarr;</span></button>
            </div>
          </form>
        </div>
      );
    };
    
export default Form;